
import parse, { domToReact } from 'html-react-parser';

interface Props {
  htmlString: string;
}

const HtmlParser = ({ htmlString }: Props) => {
  const options = {
    replace: (domNode: any) => {
      if (domNode.name === 'p') {
        // Convert <p> to <span>
        return <span>{domToReact(domNode.children)}</span>;
      }
    },
  };

  return <div>{parse(htmlString, options)}</div>;
};

export default HtmlParser;
